export const DEFAULT_ERROR_MSG = 'Something went wrong';
export const ORG_ID_IS_MISSING_ERROR_MSG =
  'Organization id is missing in the request';
export const SUBSCRIPTION_ID_IS_MISSING_ERROR_MSG =
  'Plan id is missing in the request';
export const PERMISSION_ERROR_MSG =
  "You don't have permissions for this operation";
